import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import {
  ISSUE_STATUSES,
  LINB_ISSUE_STATES
} from '../../ProjectProgression/state/issue.statuses';
import ValuesBar from 'components/ValuesBar/ValuesBar';
import {
  StyledValuesBar,
  StyledValuesBarItem
} from 'components/ValuesBar/ValuesBar.style';
import { roundValue } from 'common/utils/utils';
import useForecastTrackingEvents from '../useForecastTrackingEvents';
import usePmViewer from 'common/hooks/pm/usePmViewer';
import { startCase } from 'lodash';

const StyledValuesBarWrapper = styled.div`
  margin-left: 1rem;
  width: 40rem;
`;

const StyledIssuesStates = styled.div`
  display: flex;
  align-items: center;
  color: ${getColor('shuttleGray')};

  & > ${StyledValuesBar} {
    width: 100%;
    & ${StyledValuesBarItem} {
      height: 1.2rem;
    }
  }
`;

const IssuesStates = ({ forecast }) => {
  const trackingEvents = useForecastTrackingEvents();
  const pmViewer = usePmViewer();
  const { issuesStates } = forecast;
  if (!issuesStates) return null;

  const created = issuesStates?.[LINB_ISSUE_STATES.CREATED];
  const wip = issuesStates?.[LINB_ISSUE_STATES.WIP];
  const done = issuesStates?.[LINB_ISSUE_STATES.DONE];

  const stackingBarData = [
    {
      name: ISSUE_STATUSES[LINB_ISSUE_STATES.DONE].name,
      color: ISSUE_STATUSES[LINB_ISSUE_STATES.DONE].color,
      value: roundValue(done)
    },
    {
      name: ISSUE_STATUSES[LINB_ISSUE_STATES.WIP].name,
      color: ISSUE_STATUSES[LINB_ISSUE_STATES.WIP].color,
      value: roundValue(wip)
    },
    {
      name: ISSUE_STATUSES[LINB_ISSUE_STATES.CREATED].name,
      color: ISSUE_STATUSES[LINB_ISSUE_STATES.CREATED].color,
      value: roundValue(created)
    }
  ];

  return (
    <StyledIssuesStates>
      <header>{startCase(pmViewer.ticket.plural)} States:</header>
      <StyledValuesBarWrapper onMouseOver={trackingEvents.onHoverIssueStates}>
        <ValuesBar
          roundedView
          data={stackingBarData}
          withPercents
          withTooltip
        />
      </StyledValuesBarWrapper>
    </StyledIssuesStates>
  );
};

export default IssuesStates;
